export const maxRecords = 14;
export const MAX_RECORDS = 25;